import React, { useRef } from 'react'
import ROSFields from '../../../../SOAP/Components/ROSFields';
import TextEditor from '../../../../../../../../../../../shared-components/TextEditor';

const ROS = ({ widgetUtilities, ...props }) => {
    const quillROSRef = useRef(null);

    const {
        initialDataPatientName, initialDataAge, initialDataDOB, initialDataAddress, initialDataMobileNumber, initialDataEmail,
        subjectiveData, setSubjectiveData,
        setSaveROSData
    } = widgetUtilities;

    const handleChangeFreeText = (value, type) => {

        if (type === 'ReviewOfSystemNotes') {
            setSubjectiveData(prev => ({
                ...prev, "ReviewOfSystemNotes": value,
            }));
        }
    }
    return (
        <div className="d-flex gap-10">
        <div className="ar-form-counter flex-center">
            <p className='text text-black'>{props?.itemCount}</p>
        </div>
        <div className="d-flex flex-column gap-6 w-100"
        // id={scrollNavIDs.refSUBJECTIVEROS} onMouseEnter={() => handleHoveredItem(scrollNavIDs.refSUBJECTIVEROS)} onClick={() => handleActiveItem(scrollNavIDs.refSUBJECTIVEROS)}
        >
            <p className="heading fs-13 cursor-pointer user-select-none w-max-content"
            //  onClick={() => handleItemsExpanded('ROS')}
            >Review of System</p>
            {/* {!itemsCollapsed?.['ROS'] &&
                ( */}
            <div className="d-flex flex-column gap-6 observation-content">
                {/* {["Fields", "Both"].includes(defaultSelectedItems.reviewOfSystemType) ? */}
                <ROSFields setSaveROSData={setSaveROSData} rosData={subjectiveData.ReviewOfSystem} setSubjectiveData={setSubjectiveData} />
                {/* : <></>} */}
                {/* {["FreeText", "Both"].includes(defaultSelectedItems.reviewOfSystemType) ? */}
                <div className='d-flex flex-column gap-6'>
                    {/* {["Both"].includes(defaultSelectedItems.reviewOfSystemType) &&  */}
                    <p className="heading fs-13">ROS Notes</p>
                    {/* } */}
                    <div className="">
                        <TextEditor
                            quillRef={quillROSRef}
                            value={subjectiveData.ReviewOfSystemNotes}
                            setValue={(value) => handleChangeFreeText(value, 'ReviewOfSystemNotes')}
                            placeholderReplacement={true}
                            customDropDown={{
                                'active': true,
                                'options': [
                                    { value: initialDataPatientName, display: '$Name', },
                                    { value: initialDataAge, display: '$Age', },
                                    { value: initialDataDOB, display: '$DOB', },
                                    { value: initialDataAddress, display: '$Address', },
                                    { value: initialDataMobileNumber, display: '$Phone', },
                                    { value: initialDataEmail, display: '$Email', },
                                ]
                            }}
                            placeholder={"Detail ROS Notes..."}
                        />
                    </div>
                </div>
                {/* : <></>} */}
            </div>
            {/* )} */}
        </div>
        </div>
    )
}

export default ROS